import { Stack } from '@fluentui/react';
import { observer } from 'mobx-react';
import React from 'react';
import { FiltersState } from '../../state/FiltersState';
import { IUserConfigPackage } from '../../API';
import FilterDisplayWidget from './FilterDisplayWidget';

interface ISelectedFiltersProps {
	filters: FiltersState;
	userConfig: IUserConfigPackage;
}

class SelectedFilters extends React.Component<ISelectedFiltersProps> {
	render() {
		return (
			<Stack horizontal>
				{this.props.filters.filterFields.map((filterField) => {
					if (filterField.selectedFilterOptions.length > 0) {
						return (
							<FilterDisplayWidget
								userConfig={this.props.userConfig}
								filterField={filterField}
								filters={this.props.filters}
								key={'filterfieldwidget' + filterField.columnInfo.id}
							/>
						);
					}
					return <></>;
				})}
			</Stack>
		);
	}
}

export default observer(SelectedFilters);
